import { makeFlagParser } from '@lib/flags/flag-parser';
import { getEnvVar } from '@utils/environment';
import { useContext, useEffect, useState } from 'react';

import { FlagContext } from './flag-context';
import { FeatureFlags } from './index';

const getFlagValue = makeFlagParser({
  getEnvVar: (key: string) => {
    return getEnvVar(key) || getEnvVar('DEFAULT_FLAG_VALUE') || 'false';
  },
});

export const useFlag = <T extends keyof FeatureFlags>(
  flag: T,
): FeatureFlags[T] => {
  const { flags } = useContext(FlagContext);

  const [flagValue, setFlagValue] = useState<FeatureFlags[T]>(
    () => flags[flag] ?? getFlagValue(flag as string) ?? false,
  );

  useEffect(
    () => setFlagValue(flags[flag] ?? getFlagValue(flag as string) ?? false),
    [flags, flag],
  );

  return flagValue;
};
